// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.7.7
//   protoc               unknown
// source: qonto/transfers/sdd_collections_orchestrator/mandates/firstparty/v1/shared_get_invitation_link.proto

/* eslint-disable */

/** Request for getting public invitation link details. */
export interface ApiGetSharedInvitationLinkRequest {
  /** Unique identifier for the invitation link from URL path. */
  readonly invitationLinkId: string;
}

/** Response containing public invitation link information. */
export interface ApiGetSharedInvitationLinkResponse {
  /** Unique identifier for the invitation link. */
  readonly invitationLinkId: string;
  /** Name of the organization that owns the invitation link. */
  readonly organizationName: string;
  /** URL to the organization's logo image. */
  readonly organizationLogoUrl: string;
  /** Country of the organization that owns the invitation link. */
  readonly organizationCountry: string;
}

export const ApiGetSharedInvitationLinkRequest: MessageFns<ApiGetSharedInvitationLinkRequest> = {
  fromJSON(object: any): ApiGetSharedInvitationLinkRequest {
    return { invitationLinkId: isSet(object.invitationLinkId) ? globalThis.String(object.invitationLinkId) : "" };
  },

  toJSON(message: ApiGetSharedInvitationLinkRequest): unknown {
    const obj: any = {};
    if (message.invitationLinkId !== "") {
      obj.invitationLinkId = message.invitationLinkId;
    }
    return obj;
  },
};

export const ApiGetSharedInvitationLinkResponse: MessageFns<ApiGetSharedInvitationLinkResponse> = {
  fromJSON(object: any): ApiGetSharedInvitationLinkResponse {
    return {
      invitationLinkId: isSet(object.invitationLinkId) ? globalThis.String(object.invitationLinkId) : "",
      organizationName: isSet(object.organizationName) ? globalThis.String(object.organizationName) : "",
      organizationLogoUrl: isSet(object.organizationLogoUrl) ? globalThis.String(object.organizationLogoUrl) : "",
      organizationCountry: isSet(object.organizationCountry) ? globalThis.String(object.organizationCountry) : "",
    };
  },

  toJSON(message: ApiGetSharedInvitationLinkResponse): unknown {
    const obj: any = {};
    if (message.invitationLinkId !== "") {
      obj.invitationLinkId = message.invitationLinkId;
    }
    if (message.organizationName !== "") {
      obj.organizationName = message.organizationName;
    }
    if (message.organizationLogoUrl !== "") {
      obj.organizationLogoUrl = message.organizationLogoUrl;
    }
    if (message.organizationCountry !== "") {
      obj.organizationCountry = message.organizationCountry;
    }
    return obj;
  },
};

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

interface MessageFns<T> {
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
}
